export default __webpack_public_path__ + "static/media/LoreinaChew.0cc36e33.jpg";